var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"h-100-trim-header mt-3 mb-5 bg-light-grey"},[_c('div',{staticClass:"vertical-center text-center",attrs:{"id":"loader-text"}},[_c('h4',[_vm._v(_vm._s(_vm.loadingText))]),_c('p',{attrs:{"id":"video"}},[_c('Animation',{ref:"animation"})],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }